var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 12,
  fill: "none",
  viewBox: "0 0 18 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#017860",
  d: "M0 12h18v-2H0zm0-5h18V5H0zm0-7v2h18V0z"
})));
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxOCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTJIMThWMTBIMFYxMlpNMCA3SDE4VjVIMFY3Wk0wIDBWMkgxOFYwSDBaIiBmaWxsPSIjMDE3ODYwIi8+Cjwvc3ZnPgo=";